module.exports = __webpack_public_path__ + "static/world-8ebd30b541ddc28f1728fd2afe00311d.svg";